import React from 'react';
import Hero from './sections/Hero';
import SEO from '../../components/SEO/SEO';

import Services from './sections/Services';
import Projects from './sections/Projects';
import Features from './sections/Features';
import Stats from './sections/Stats';
import Blog from './sections/Blog';
import Testimonials from './sections/Testimonials';
import CTA from './sections/CTA';
import './Home.css';

const Home = () => {
    return (
        <div className="home-page">
            <SEO
                title="Top Digital Marketing Agency"
                description="Digi Network is an elite digital marketing agency in Dubai helping businesses grow with SEO, Paid Ads, Web Development, and Email Marketing."
                canonical="/"
            />
            <Hero />
            <Services />
            <Projects />
            <Features />
            <Stats />
            <Blog />
            <Testimonials />
            <CTA />
        </div>
    );
};

export default Home;
